module.exports = "/images/x_twitter_sm.svg?669ecd1d478ef72313aaa4dc95db4f7c";